import { IDeclinedTransactionsState } from "./types";
import { ActionTree } from "vuex";
import { IRootState } from "@/store/types";
import { DECLINED_TRANSACTIONS_MUTATIONS } from "./mutations";
import api from "@/api/declinedTransactions/api";
import { UI } from "@/store/ui";
import { ERROR_MESSAGES } from "@/constants/errors";

export namespace DECLINED_TRANSACTIONS_ACTIONS {
  export const LOAD_DECLINED_TRANSACTIONS_LIST = "loadDeclinedTransactionsList";
  export const LOAD_DECLINE_CODES = "loadDeclineCodes";
}

export const actions: ActionTree<IDeclinedTransactionsState, IRootState> = {
  async [DECLINED_TRANSACTIONS_ACTIONS.LOAD_DECLINED_TRANSACTIONS_LIST](
    { commit, dispatch, state },
    { pagination }
  ): Promise<void> {
    try {
      dispatch(DECLINED_TRANSACTIONS_ACTIONS.LOAD_DECLINE_CODES);

      let data = [];
      let total = 0;

      const filters =
        state.dataTables.declinedTransactionsList.declinedTransactionFilters;
      const response = await api.searchTransactions(
        pagination.rowsPerPage,
        pagination.rowsPerPage * (pagination.page - 1),
        filters.cardNumber,
        filters.locationCode,
        filters.parentTerminalId,
        filters.childTerminalId,
        filters.declineCode,
        filters.voucherTransactionNo,
        filters.totalTransactionValue,
        filters.startDateTime,
        filters.endDateTime
      );
      data = response.results;
      total = response.totalResults;

      commit(
        DECLINED_TRANSACTIONS_MUTATIONS.SET_DECLINED_TRANSACTIONS_LIST,
        data
      );
      commit(
        DECLINED_TRANSACTIONS_MUTATIONS.SET_DECLINED_TRANSACTIONS_LIST_TOTAL,
        total
      );
    } catch (error) {
      dispatch(
        UI.NS(UI.ACTIONS.ADD_TOAST),
        {
          id: "failed-load-declined-transactions-list",
          text: ERROR_MESSAGES.LOAD_DECLINED_TRANSACTIONS_LIST_ERROR,
          error,
        },
        { root: true }
      );
    }
  },
  async [DECLINED_TRANSACTIONS_ACTIONS.LOAD_DECLINE_CODES]({
    commit,
    state,
  }): Promise<void> {
    if (state.declineCodes.length !== 0) {
      return;
    }

    const response = await api.getDeclineCodes();
    commit(DECLINED_TRANSACTIONS_MUTATIONS.SET_DECLINE_CODES, response.results);
  },
};
